import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import "./AddVideo.css";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

const AddVideo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, mode, page } = location.state || {};
  const isViewMode = mode === "view";
  const isEditMode = mode === "edit";
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    video_link: "",
  });

  useEffect(() => {
    console.log("videoData", data);

    if (data && (isViewMode || isEditMode)) {
      setFormData({
        name: data?.name || "",
        video_link: data?.video_link || "",
      });
    }
  }, [data, isViewMode, isEditMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("SADDSLKDAKd", name, value);
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));

  };

  const handleEdit = (e) => {
    e.preventDefault();

    // Validation logic
    const requiredFields = [
      { key: "name", label: "Video Name" },
      { key: "video_link", label: "Video Link" },
    ];

    if (!formData.name) {
      toast.error(`Please enter video name`);
      return;
    }


    if (!formData.video_link) {
      toast.error(`Kindly add the video link`);
      return;
    }



    setLoading(true);
    let payload = {
      name: formData.name,
      video_link: formData?.video_link,
      link_type: 1
    };
    console.log("payload Data:", formData, data, payload);

    put(URLS.VIDEOUPDATE + data?.id + "/", payload)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "Admin Update successfully");
          setLoading(false);
          setFormData({
            name: "",
            video_link: "",
          });
          navigate("/video", { state: { page: page || 1 } });
        } else {
          setLoading(false);
          // toast.error(res?.message || "Failed to save admin");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        // toast.error(err?.message || "An error occurred");
      });
  };

  const handleSave = (e) => {
    e.preventDefault();
    console.log("formData.roleformData.role", formData.role);

    // Validation logic
    const requiredFields = [
      { key: "name", label: "Video Name" },
      { key: "video_link", label: "Video Link" },
    ];

    if (!formData.name) {
      toast.error(`Please enter video name`);
      return;
    }


    if (!formData.video_link) {
      toast.error(`Kindly add the video link`);
      return;
    }


    console.log("Form Data:", formData);
    setLoading(true);
    let payload = {
      name: formData.name,
      video_link: formData.video_link,
      link_type: 1
    };
    post(URLS.VIDEOCREATE, payload)
      .then((res) => {
        if (res?.status === "success") {
          toast.success(res?.message || "Admin saved successfully");
          setLoading(false);
          setFormData({
            name: "",
            video_link: "",
          });
          navigate("/video", { state: { page: page || 1 } });
        } else {
          setLoading(false);
          // toast.error(res?.message || "Failed to save admin");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err", err);
        // toast.error(err?.message || "An error occurred");
      });
  };



  return (
    <>
      <PageHeader
        title={isViewMode ? "View Video" : "Add Video"}
        showBackButton={true}
        onBackClick={() => navigate("/video", { state: { page: page || 1 } })}
      />
      <div className="add-admin-container">
        <form className="add-admin-form" onSubmit={handleSave} noValidate>
          <div className="form-row">

            <div className="form-group">
              <label>Video Name</label>
              <input
                type="text"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                placeholder="Enter Video Name"
                required
                disabled={isViewMode}
              />
            </div>

            <div className="form-group">
              <label>Video Link</label>
              <input
                type="text"
                name="video_link"
                value={formData.video_link || ""}
                onChange={handleChange}
                placeholder="Enter video link"
                required
                disabled={isViewMode}
              />
            </div>

          </div>

          {!isViewMode && (
            <div className="form-actions">
              {isEditMode ? (
                <button
                  type="button"
                  className="btn-edit"
                  onClick={() =>
                    navigate("/video", { state: { page: page || 1 } })
                  }
                >
                  Back
                </button>
              ) : (
                <button
                  type="button"
                  className="btn-back"
                  onClick={() =>
                    navigate("/video", { state: { page: page || 1 } })
                  }
                >
                  Back
                </button>
              )}
              <button
                type={isEditMode ? "button" : "submit"}
                className="btn-save"
                onClick={isEditMode ? handleEdit : undefined}
              >
                {isEditMode ? "Update" : "Save"}
              </button>
            </div>
          )}
        </form>
        {loading && <Loader />}
      </div>
    </>
  );
};

export default AddVideo;
